module.exports = __webpack_public_path__ + "src/img/next-generation/paolo-mantini.b9b99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/next-generation/paolo-mantini.jpg
// module id = 127
// module chunks = 0